import EpiApiClient from "@/services/serviceClients/epiApiClient";
import { GLOBAL_CART_API_PATH } from "@/config/constants";

class globalCartService {
    static async getUserCart(cartData) {
        try {
            const response = await EpiApiClient.get(GLOBAL_CART_API_PATH, cartData);
            return { success: true, data: response.data };
        } catch (e) {
            return { success: false, error: e.response.data.error_description, data: null };
        }
    }

    static async saveUserCart(cartData) {
        try {
            const response = await EpiApiClient.post(GLOBAL_CART_API_PATH, cartData);
            return { success: true, data: response.data };
        } catch (e) {
            return { success: false, error: e.response.data.error_description, data: null };
        }
    }

    static async deleteUserCart(cartData) {
        try {
            const response = await EpiApiClient.delete(GLOBAL_CART_API_PATH, cartData);
            return { success: true, data: response.data };
        } catch (e) {
            return { success: false, error: e.response.data.error_description, data: null };
        }
    }
}

export default globalCartService;